import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  getListingFullAddressString,
} from 'common/listingHelpers';

import {
  createFormValidationFn,
  hideFieldIf,
} from 'client/helpers/formikHelpers';

import {
  cleanMarketingPartnerListingFormValues,
} from 'common/marketingPartnerListingHelpers';

import {
  SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING,
} from 'api/actionTypes';

import {
  MARKETING_PARTNER_LISTING_STATUS_WITHDRAWN,
  MARKETING_PARTNER_LISTING_WITHDRAWN_REASON_OTHER,
  MARKETING_PARTNER_LISTING_WITHDRAWN_REASON_OPTION_ITEMS,
} from 'common/marketingPartnerListingConstants';

import log from 'client/lib/log';

import postWithState from 'client/actions/postWithState';

import SrFooterButton from 'client/components/SrFooterButton/SrFooterButton';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrPartnerPageV2, { SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL } from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

class SrPartnerWithdrawFromMarketForm extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired,
    marketingPartnerListing: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      shouldShowSuccessModal: false,
      shouldShowLoadingScreen: false,
    };
  }

  _onSubmit = (formValues) => {
    const { partner, marketingPartnerListing, dispatch, onSubmit } = this.props;

    const updates = cleanMarketingPartnerListingFormValues({
      ...marketingPartnerListing,
      ...formValues,
      status: MARKETING_PARTNER_LISTING_STATUS_WITHDRAWN,
      partnerId: partner.id,
    });

    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING,
      payload: {
        updates,
        marketingPartnerListingId: marketingPartnerListing.id,
      },
      onSuccess: () => {
        this.setState({
          shouldShowSuccessModal: true,
        });
        setTimeout(() => {
          onSubmit();
        }, 1300);
      },
      onError: (error) => {
        log.error(error);
      },
    });
  }

  _getFormFields = ({ values = {} } = {}) => {
    return [
      {
        id: 'withdrawalReason',
        title: 'Reason for this change?',
        type: 'select',
        properties: {
          enableResetOption: true,
          choices: MARKETING_PARTNER_LISTING_WITHDRAWN_REASON_OPTION_ITEMS,
        },
        validations: ['required'],
      },
      hideFieldIf(values.withdrawalReason !== MARKETING_PARTNER_LISTING_WITHDRAWN_REASON_OTHER, {
        id: 'withdrawalReasonProvided',
        title: 'Other reason for withdrawing?',
        type: 'long_text',
        properties: {
          placeholder: 'Write here...',
        },
      }),
    ];
  };

  render() {
    const {
      marketingPartnerListing,
      onBack,
    } = this.props;

    const {
      shouldShowSuccessModal,
      shouldShowLoadingScreen,
    } = this.state;

    if (shouldShowLoadingScreen) {
      return <div className='loading-gif' />;
    }

    return (
      <Formik
        ref={(formik) => {
          this.formik = formik;
        }}
        validate={(values) => {
          const formFields = this._getFormFields({ values });
          return createFormValidationFn(formFields)(values);
        }}
        onSubmit={(formValues) => {
          this._onSubmit(formValues);
        }}
      >
        {(formikBag) => {

          return (
            <>
              <Form className='form'>
                <SrPartnerPageV2
                  onBack={onBack}
                  navbarTitle={getListingFullAddressString(marketingPartnerListing.listing)}
                  pageHeader='Withdraw my listing'
                  headerSize={SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL}
                >
                  <SrBox
                    backgroundColor='#ffffff'
                    borderRadius='14px'
                    padding='22px 19px 26px 19px'
                  >
                    {this._getFormFields({
                      values: formikBag.values,
                    }).map((formField, index) => (
                      <SrFormikField
                        formField={formField}
                        formikBag={formikBag}
                        theme={SR_FIELD_THEME_ADOBE}
                        key={formField.id}
                        margin={index === 0 ? '0' : null}
                      />
                    ))}
                  </SrBox>
                </SrPartnerPageV2>
                <SrStaticFooter>
                  <SrText
                    display='block'
                    lineHeight='25px'
                    font='greycliff'
                    color='grey600'
                    fontSize='13px'
                    weight='500'
                  >
                    Updates can take 24 hours to syndicate
                  </SrText>
                  <SrFooterButton
                    disabled={!formikBag.isValid}
                    hasBoxShadow={formikBag.isValid}
                  >
                    Withdraw Listing
                  </SrFooterButton>
                </SrStaticFooter>
              </Form>
              {shouldShowSuccessModal && (
                <SrSimpleMessageModal
                  underline
                  iconUrl='/images/checkmark-circle-large-green.svg'
                  headline='Saved!'
                  message='Showing equipment will be uninstalled'
                  maxWidth='375'
                  minWidth='320'
                  theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
                />
              )}
            </>
          );
        }}
      </Formik>
    );
  }
}

SrPartnerWithdrawFromMarketForm.displayName = 'SrPartnerWithdrawFromMarketForm';

export default SrPartnerWithdrawFromMarketForm;
